import { render, staticRenderFns } from "./DictionaryProfiles.vue?vue&type=template&id=ebbc23e8&"
import script from "./DictionaryProfiles.vue?vue&type=script&lang=js&"
export * from "./DictionaryProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports